import React from 'react';
import { StyleSheet, Text, View } from '@react-pdf/renderer';

interface BudgetTotalIndicatorPDFProps {
  allocated: number;
  available: number;
  hcpData: {
    provider_held?: number;
    commonwealth_held?: number;
    client_held?: number;
  };
}

const currencyFormatter = new Intl.NumberFormat('en-AU', {
  style: 'currency',
  currency: 'AUD',
  minimumFractionDigits: 0,
});

const styles = StyleSheet.create({
  container: {
    padding: 4,
    border: '1px solid #eee',
    borderRadius: 3,
    backgroundColor: '#f9f9f9',
    marginBottom: 8,
  },
  row: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    marginBottom: 2,
  },
  leftCol: {
    flex: 1,
    marginRight: 12,
    justifyContent: 'flex-start',
  },
  rightCol: {
    flex: 1,
    alignItems: 'flex-end',
    marginRight: 2,
  },
  label: {
    fontWeight: 'bold',
    fontSize: 9,
    marginLeft: 4,
    marginRight: 2,
  },
  currencyValue: {
    fontSize: 9,
    marginLeft: 2,
  },
  overBudget: {
    color: '#c00',
    fontWeight: 'bold',
  },
  gstInfo: {
    fontSize: 7,
    textAlign: 'right',
    color: '#666',
    marginTop: 2,
  },
  subRow: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 2,
  },
});

const BudgetTotalIndicatorPDF: React.FC<BudgetTotalIndicatorPDFProps> = ({
  allocated,
  available,
  hcpData: { provider_held, commonwealth_held, client_held },
}) => {
  const isOver = allocated > available;

  return (
    <View style={styles.container}>
      <View style={styles.row}>
        {/* Left: HCP Funds */}
        <View style={styles.leftCol}>
          <Text style={styles.label}>HCP Unspent Funds</Text>
          <View style={styles.subRow}>
            <Text style={styles.label}>Provider Held:</Text>
            <Text style={styles.currencyValue}>{currencyFormatter.format(provider_held ?? 0)}</Text>
            <Text style={styles.label}>Commonwealth Held:</Text>
            <Text style={styles.currencyValue}>{currencyFormatter.format(commonwealth_held ?? 0)}</Text>
            <Text style={styles.label}>Client Held:</Text>
            <Text style={styles.currencyValue}>{currencyFormatter.format(client_held ?? 0)}</Text>
          </View>
        </View>
        {/* Right: Totals */}
        <View style={styles.rightCol}>
          <View style={styles.subRow}>
            <Text style={styles.label}>Allocated:</Text>
            <Text style={isOver ? [styles.currencyValue, styles.overBudget] : styles.currencyValue}>
              {currencyFormatter.format(allocated)}
            </Text>
            <Text style={styles.label}>Available:</Text>
            <Text style={styles.currencyValue}>{currencyFormatter.format(available)}</Text>
          </View>
          <Text style={styles.gstInfo}>All prices budgeted are considered GST Exclusive</Text>
        </View>
      </View>
    </View>
  );
};

export default BudgetTotalIndicatorPDF;
